import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserFormComponent } from './user-form.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '@fuse/shared.module';
import { UserService } from './user.service';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { AngularDualListBoxModule } from '../dual-list/angular-dual-listbox.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {AttributesModule} from '../attributes/attributes.module';
import {TranslateModule} from '@ngx-translate/core';




@NgModule({
    declarations: [
        UserFormComponent
    ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        FuseSharedModule,
        AngularDualListBoxModule,
        MatCheckboxModule,
        TranslateModule,
        AttributesModule
    ],
    exports: [
        UserFormComponent
    ],
    providers : [ 
        UserService
    ]
})
export class UserFormModule { }
